import { Check } from "@/components/ui/icons";
import { Pressable, Text } from "react-native";

import { cn } from "@/lib/ui/cn";
import { useThemeColors } from "@/theme/theme";

/** One selectable storefront facet pill: the Location row and every pill facet in the Filters
 *  sheet (TRO-1095). A selected pill carries a check as well as color, so it reads without hue. */
export function BrowsePill({
  label,
  accessibilityLabel,
  selected,
  onPress,
  testID,
}: {
  label: string;
  accessibilityLabel: string;
  selected: boolean;
  onPress: () => void;
  testID?: string;
}) {
  const colors = useThemeColors();
  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ selected }}
      className={cn(
        "min-h-11 flex-row items-center gap-1.5 rounded-full border px-3",
        selected ? "border-primary bg-accent-soft" : "border-border bg-surface",
      )}
    >
      {selected ? <Check size={15} color={colors.primary} /> : null}
      <Text className={cn("font-label text-sm", selected ? "text-primary" : "text-foreground")}>
        {label}
      </Text>
    </Pressable>
  );
}
